/* istanbul ignore file */
import React from 'react';

import { SOMETHING_WENT_WRONG_COPY } from 'src/components/organisms/Signup/constants/copy';
import * as styles from 'src/styles/styles';

export const ApplicationError = () => (
  <section css={styles.pageSection}>
    <h2 css={styles.finalSectionHeading}>{SOMETHING_WENT_WRONG_COPY}</h2>
    <p css={styles.finalSectionText}>Please try again later.</p>
  </section>
);
